/**
* Featured Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
// import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'featured-services',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const tabContainer = $( '.tab-content-container' );

      tabContainer.each( function( i ) {
        const elementHeight = $( this ).find( '.set-height' ).outerHeight();
        console.log( elementHeight );
        if ( i !== 0 ) {
          $( this ).css( 'display', 'none' );
        }
        $( this ).css( 'position', 'absolute' );
        $( this ).outerHeight( elementHeight );
      } );

      const componentHeight = $( '.featured-services-desktop' ).outerHeight();
      console.log( componentHeight );

      $( 'button.easy-toggle-fade-toggle' ).on( 'click', function() {
        const target = $( this ).data( 'toggle-target' );
        const activeHeight = $( target ).find( '.set-height' ).outerHeight();

        if ( componentHeight < activeHeight ) {
          $( '.featured-services-desktop' ).outerHeight( activeHeight );
          console.log( 'component smaller than active', componentHeight, activeHeight );
        } else {
          $( '.featured-services-desktop' ).outerHeight( componentHeight );
          console.log( 'component larger than active', componentHeight, activeHeight );
        }
      } );

      $( 'button.easy-toggle-fade-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).fadeToggle();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-services', COMPONENT );
} )( app );
